import React from 'react';
import { Mail, Phone, MapPin, Facebook, Twitter, Instagram, Linkedin } from 'lucide-react';
import Logo from './Logo';

const Footer = () => {
  const footerLinks = {
    'Services': [
      { name: 'Get Quote', href: '/pricing' }
    ],
    'Support': [
      { name: 'Contact Us', href: 'mailto:sales@washmii.com' }
    ],
    'Legal': [
      { name: 'Terms of Service', href: '/terms' },
      { name: 'Privacy Policy', href: '/privacy' }
    ]
  };

  const socialLinks = [
    { icon: Facebook, href: 'https://facebook.com/washmii', label: 'Facebook' },
    { icon: Twitter, href: 'https://twitter.com/washmii', label: 'Twitter' },
    { icon: Instagram, href: 'https://instagram.com/washmii', label: 'Instagram' },
    { icon: Linkedin, href: 'https://linkedin.com/company/washmii', label: 'LinkedIn' }
  ];

  const contactInfo = [
    { icon: Mail, text: 'sales@washmii.com', href: 'mailto:sales@washmii.com' },
    { icon: MapPin, text: 'Chicago and surrounding areas' }
  ];

  return (
    <footer className="bg-gray-900 text-white">
      <div className="container mx-auto px-6 py-16">
        <div className="max-w-7xl mx-auto">
          {/* Top Section */}
          <div className="grid grid-cols-1 lg:grid-cols-4 gap-12 mb-12">
            {/* Company Info */}
            <div className="lg:col-span-2 space-y-6">
              <div className="text-white">
                <Logo size="large" showText={true} className="text-white [&>div>span]:text-white [&>div>span:last-child]:text-gray-300" />
              </div>
              
              <p className="text-gray-300 max-w-md">
                Premium linen rental service for short-term rental operators. 
                Simplifying property management with quality linens and reliable service.
              </p>
              
              <div className="space-y-3">
                {contactInfo.map((contact, index) => (
                  <div key={index} className="flex items-center gap-3">
                    <contact.icon className="w-4 h-4 text-gray-400 flex-shrink-0" />
                    {contact.href ? (
                      <a 
                        href={contact.href} 
                        className="text-gray-300 hover:text-white transition-colors text-sm"
                      >
                        {contact.text}
                      </a>
                    ) : (
                      <span className="text-gray-300 text-sm">{contact.text}</span>
                    )}
                  </div>
                ))}
              </div>
            </div>

            {/* Links Columns */}
            {/* Footer links section hidden as requested */}
          </div>

          {/* Bottom Section */}
          <div className="border-t border-gray-800 pt-8">
            <div className="flex flex-col md:flex-row justify-between items-center gap-6">
              {/* Copyright */}
              <div className="text-gray-400 text-sm text-center md:text-left">
                <p>© 2025 LaundryBnB by Washmii. All rights reserved.</p>
                <p className="mt-1">Licensed linen rental service.</p>
              </div>

              {/* Social Links */}
              <div className="flex items-center gap-4">
                {socialLinks.map((social) => (
                  <a
                    key={social.label}
                    href={social.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-8 h-8 bg-gray-800 rounded-full flex items-center justify-center hover:bg-gray-700 transition-colors"
                    aria-label={social.label}
                  >
                    <social.icon className="w-4 h-4 text-gray-300" />
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;